//import packages from node modules
import React, { useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { withRouter } from "react-router-dom"
import { reduxForm } from "redux-form"
import PropTypes from "prop-types"

//import utilities functions
import { ADD_DOMAIN_PAGE, EDIT_DOMAIN_PAGE } from "../../../../utilities/function/common"

import { getCartToken } from "../../../../utilities/function/cartToken"

import {
    getDataFromSuccessResponse,
    getErrorFromFailResponse,
    isResponseCancelled
} from "../../../../utilities/function/apiResponse"

import { getPageByURL } from "../../../../utilities/function/urlparams"

import PRODUCT_API, { cancelGetUpsell } from "../../../../utilities/api/product"

//import shared components
import SelectButtonDomain from "../selectbutton/domain"

//import internals
import { ERROR_UPSELL, LOAD_UPSELL, SelectDomainConfigContext, SUCCESS_UPSELL } from "./reducer"
import DomainConfig from './DomainConfig'

//define shared variables
export const SELECT_DOMAIN_CONFIG_FORM = 'SelectDomainConfigForm'

//main component
let SelectDomainConfigForm = (props) => {
    const { domainList, handleSubmit, location } = props
    const { dispatch } = useContext(SelectDomainConfigContext)
    const initUpsellFlag = useRef(false)
    const cleanUpsellFlag = useRef(false)
    const { configurations, cartStatus } = useSelector(state => ({
        configurations: state.app.configurations,
        cartStatus: state.app.cartStatus
    }))

    useEffect(() => {
        const pageType = getPageByURL(location.search)
        if (pageType === ADD_DOMAIN_PAGE || pageType === EDIT_DOMAIN_PAGE) {
            if (!initUpsellFlag.current && (cartStatus === 'success' || !getCartToken() || getCartToken() === 'undefined')) {
                if (cancelGetUpsell) {
                    cancelGetUpsell()
                }

                dispatch({
                    type: LOAD_UPSELL
                })

                PRODUCT_API.getUpsell().then(response => {
                    const requestUpsellData = getDataFromSuccessResponse(response)
                    dispatch({
                        type: SUCCESS_UPSELL,
                        requestUpsellData
                    })
                    initUpsellFlag.current = true
                }, error => {
                    const requestUpsellError = getErrorFromFailResponse(error)
                    if (!isResponseCancelled(requestUpsellError)) {
                        dispatch({
                            type: ERROR_UPSELL,
                            requestUpsellError
                        })
                    }
                })
            }
        }

        return (() => {
            if (cancelGetUpsell) {
                cancelGetUpsell()
            }
        })
    }, [initUpsellFlag, dispatch, configurations, cleanUpsellFlag, cartStatus, location])

    const renderDomainConfigList = () => {
        if (domainList && domainList.length) {
            const renderList = () => {
                return domainList.map((item, index) => <DomainConfig key={index} item={item} index={index}/>)
            }

            return (
                <div className={'of-domain-config-list clearfix'}>
                    {renderList()}
                </div>)
        }
    }

    return (<form className={'of-select-domain-config-form'} onSubmit={handleSubmit}>
        <div className={'of-select-domain-config-form__wrapper'}>
            {renderDomainConfigList()}
            <SelectButtonDomain/>
        </div>
    </form>)
}

SelectDomainConfigForm = withRouter(SelectDomainConfigForm)
SelectDomainConfigForm = reduxForm({
    form: SELECT_DOMAIN_CONFIG_FORM,
    enableReinitialize: true
})(SelectDomainConfigForm)
SelectDomainConfigForm.propTypes = {
    domainList: PropTypes.any,
    handleSubmit: PropTypes.func,
    location: PropTypes.any
}

export default SelectDomainConfigForm